<template>
    <div class="notification__card" >
        <div class="notification__card__header">
            <div class="notification__card__header__left">
                <i :class="cardIcon" class="notification__card__header__left__icon"></i>
                <p class="notification__card__header__left__text">
                    {{ cardIconText }}
                </p>
            </div>
            <!-- <div class="notification__card__header__right">{{ cardPersonPic }}</div> -->
        </div>
        <div class="notification__card__info">
            <h4 class="notification__card__title">{{ cardTitle }}</h4>
            <p class="notification__card__description">{{ cardDescription }}</p>
        </div>
        <div class="notification__card__footer">
            <div class="notification__card__footer__left" @click="toggleCardChecked(cardObj)">
                <i :class="[
                    isChecked ? 'fas fa-check-circle' : 'far fa-circle',
                    'notification__card__footer__icon',
                ]"></i>
                <p class="notification__card__footer__text">{{ isChecked ? 'Visualizado' : 'Novo' }}</p>
            </div>
            <div @click="onClickNotification(cardObj)"  class="notification__card__footer__button btn btn-third btn-sm">
                Visualizar
            </div>
        </div>
    </div>
</template>

<script>
import NotificationsCardRepository from '@/shared/http/repositories/crm/notificationscard.js'

export default {
  name: 'NotificationCard',
  props: {
    cardIcon: {
      type: String,
      required: true
    },
    cardIconText: {
      type: String,
      required: true
    },
    cardPersonPic: {
      type: String,
      required: true
    },
    cardTitle: {
      type: String,
      required: true
    },
    cardDescription: {
      type: String,
      required: true
    },
    cardChecked: {
      type: Boolean,
      default: false
    },
    showCard: {
      type: Boolean,
      default: true
    },
    cardObj: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isChecked: this.cardChecked
    }
  },
  methods: {
    toggleCardChecked (obj) {
      NotificationsCardRepository.Update(obj.id)
        .then(response => {
          if (response.status === 200) {
            this.$emit('update-card', this.cardObj)
          }
        })
        .catch(this.onException)
    },
    onClickNotification (obj) {
      if (obj.visualizado === true) {
        this.redireciona(obj)
        return
      }
      NotificationsCardRepository.Update(obj.id)
        .then(response => {
          if (response.status === 200) {
            this.redireciona(obj)
          }
        })
        .catch(this.onException)
    },
    redireciona (obj) {
      this.$emit('close-notification')
      this.$emit('update-card', this.cardObj)
      this.$emit('openCard', obj.card.id)
    }
  }
}
</script>

<style lang="scss">
.notification {

    &__card {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 1rem;
        background-color: #2F3136;
        width: 100%;
        border-radius: 4px;

        &__header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;

            &__left {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                gap: .5rem;
                margin: .5rem .5rem 0 .25rem;

                &__icon {
                    margin: 0 !important;
                    color: #04A791 !important;
                    font-size: 1.2rem;
                    line-height: 100%;
                }

                &__text {
                    font-weight: 700;
                    font-size: .9rem;
                    line-height: 100%;
                    letter-spacing: -0.04em;
                    color: #04A791;
                    margin: 0;
                }
            }
        }

        &__info {
            width: 100%;
            padding: 0 .5rem;
            text-align: left;
        }

        &__title {
            font-weight: 600;
            font-size: 1.25rem;
            line-height: auto;
            letter-spacing: -0.04em;
            text-transform: uppercase;
            color: #FFFFFF;

            margin-bottom: .25rem;
        }

        &__description {
            width: 100%;
            font-size: .75rem;
            line-height: auto;
            letter-spacing: -0.04em;
            color: #B8B9BA;
            margin-bottom: 0;
        }

        &__footer {
            display: flex;
            justify-content: space-between;
            align-items: center;

            width: 100%;
            padding: .5rem;
            border-top: solid 1px #484A4E;

            &__left {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                gap: .5rem;
                color: #04A791;
                cursor: pointer;
            }

            &__icon {
                margin: 0 !important;
                color: #04A791 !important;
                font-size: 1.5rem;
                width: auto !important;
            }

            &__text {
                margin: 0;
                font-size: 1rem;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/UI/notificacao/Card.vue